import React, { useContext, useEffect, useRef } from "react";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import globalContext from "../../Contexts/GlobalContext";
import MenuBar from "../menubar/MenuBar";
import { BsQuestionCircle } from "react-icons/bs";
import "./Header.css";
export default function Header({ setHeaderRef, forwardRef, relt }) {
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const navigate = useNavigate();
  const hF = useRef();
  const [isMenuBarOpen, setIsMenuBarOpen] = useState("");
  useEffect(() => {
    // setHeaderRef(hF);
  }, []);
  window.addEventListener("click", () => {
    if (isMenuBarOpen === "true") {
      setIsMenuBarOpen("false");
    }
  });
  const contextData = useContext(globalContext);

  function closeWindow() {
    Window.close();
  }

  return (
    <>
      <MenuBar
        isMenuBarOpen={isMenuBarOpen}
        setIsMenuBarOpen={setIsMenuBarOpen}
      />
      <div
        ref={forwardRef}
        className={`${relt} relative w-full h-[15.3vw] px-[7.64840451876135vw] py-[1.808919600952808vw] top-0 flex items-center justify-between z-[999]`}
      >
        <div className="absolute w-full h-[15.37699582557015vw] top-0 right-0 -z-10">
          <svg
            width="100%"
            height="15.37699582557015vw"
            viewBox="0 0 1321 203"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_47_10)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M475.099 174.897C476.463 174.897 477.554 175.169 478.919 175.169C536.217 193.45 597.335 203 660.636 203C723.937 203 784.783 193.45 842.081 175.169C843.445 175.169 844.81 174.897 845.901 174.897H1320.66V0H0.340698V174.897H475.099Z"
                fill="#FEC42B"
              />
            </g>
            <defs>
              <clipPath id="clip0_47_10">
                <rect width="1321" height="203" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div
          className="w-[7.131907266338058vw] h-[3.554161458456168vw]"
          onClick={(e) => {
            e.stopPropagation();
            setIsMenuBarOpen("true");
          }}
        >
          <svg
            width="7.131907266338058vw"
            height="3.554161458456168vw"
            viewBox="0 0 94 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_47_3)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M88.577 10.8462C92.1924 10.8462 92.1924 7.23077 92.1924 3.61538C92.1924 3.61538 92.1924 3.61538 92.1924 0H88.577H5.42312C5.42312 0 5.42312 0 1.80774 0C1.80774 3.61538 1.80774 3.61538 1.80774 3.61538C1.80774 7.23077 1.80774 7.23077 1.80774 7.23077C5.42312 7.23077 5.42312 10.8462 5.42312 10.8462H88.577Z"
                fill="#17313A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M88.577 28.9231C92.1924 28.9231 92.1924 25.3077 92.1924 21.6923C92.1924 21.6923 92.1924 21.6923 92.1924 18.0769H88.577H5.42312C5.42312 18.0769 5.42312 18.0769 1.80774 18.0769C1.80774 21.6923 1.80774 21.6923 1.80774 21.6923C1.80774 25.3077 1.80774 25.3077 1.80774 25.3077C5.42312 25.3077 5.42312 28.9231 5.42312 28.9231H88.577Z"
                fill="#17313A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M88.577 47C92.1924 47 92.1924 43.3846 92.1924 39.7692C92.1924 39.7692 92.1924 39.7692 92.1924 36.1538H88.577H5.42312C5.42312 36.1538 5.42312 36.1538 1.80774 36.1538C1.80774 39.7692 1.80774 39.7692 1.80774 39.7692C1.80774 43.3846 1.80774 43.3846 1.80774 43.3846C5.42312 43.3846 5.42312 47 5.42312 47H88.577Z"
                fill="#17313A"
              />
            </g>
            <defs>
              <clipPath id="clip0_47_3">
                <rect width="94" height="47" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div className="w-[9.665094339622642vw] h-[9.433962264150943vw]">
          <svg
            width="9.665094339622642vw"
            height="9.433962264150943vw"
            viewBox="0 0 41 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.9041 14.937H28.0995C27.498 14.937 26.8964 14.6362 26.5957 14.0347L25.9941 13.4332C24.1895 11.3278 22.0841 9.52314 19.6779 8.32006C16.6702 6.51543 13.3617 5.61312 10.0533 5.01158C8.85017 5.01158 7.94786 5.61312 7.34632 6.8162C4.03784 15.2378 4.03784 24.8625 7.34632 33.284C7.94786 34.4871 8.85017 35.3894 10.0533 35.0887C13.3617 34.7879 16.6702 33.5848 19.6779 31.7802C22.0841 30.2763 24.1895 28.7725 25.9941 26.6671L26.5957 26.0655C26.8964 25.464 27.498 25.1632 28.0995 25.1632H29.9041C30.5057 25.1632 31.1072 25.464 31.408 26.0655C31.7088 26.6671 31.408 27.2686 31.408 27.5694C29.0018 30.8779 25.6933 33.5848 22.0841 35.6902C18.4748 37.7956 14.5648 38.9987 10.6548 39.2995C7.04555 39.901 4.33861 37.7956 3.13553 34.4871C-0.473724 24.8625 -0.473724 14.3355 3.13553 4.71081C4.63938 1.40233 7.34632 -0.703069 10.6548 -0.101527C14.8656 0.500015 18.7756 1.7031 22.0841 3.80849C25.6933 5.91389 28.7011 8.62083 31.408 11.6285C31.7088 12.2301 31.7088 12.8316 31.408 13.4332C31.1072 14.0347 30.5057 14.3355 29.9041 14.3355V14.937Z"
              fill="#153038"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M38.6265 17.9447H24.1895C23.2872 17.9447 22.6856 18.5463 22.0841 19.1478C21.4825 20.0501 21.4825 20.6517 22.0841 21.554C22.3849 22.4563 23.2872 22.7571 24.1895 22.7571H38.6265C39.8296 22.7571 41.0327 21.554 41.0327 20.3509C41.0327 18.847 40.1303 17.9447 38.6265 17.9447Z"
              fill="#153038"
            />
          </svg>
        </div>
        <div
          className={`w-[7.131907266338058vw] h-[4.318294379849532vw] ${
            window.location.pathname === "/short-terms" ||
            window.location.pathname === "/mid-terms" ||
            window.location.pathname === "/long-terms"
              ? "opacity-0"
              : ""
          } ${window.location.pathname === "/add-car" ? "-z-50" : ""}`}
          onClick={() => {
            if (
              window.location.pathname === "/short-terms" ||
              window.location.pathname === "/mid-terms" ||
              window.location.pathname === "/long-terms"
            ) {
            } else {
              if (window.location.pathname == "/violation-inquiry-result") {
                navigate("/payEst", { replace: true });
              } else {
                window.history.back();
              }
            }
          }}
        >
          <svg
            width="7.131907266338058vw"
            height="4.318294379849532vw"
            viewBox="0 0 30 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_54_92)">
              <path
                d="M7.07999 2.87999H24C25.44 2.87999 26.88 3.59999 27.96 4.67999C29.04 5.75999 29.76 7.19999 29.76 8.63999V11.88C29.76 13.68 29.04 15.12 27.96 16.2C26.88 17.28 25.44 18 24 18H1.67999C-0.480006 17.64 -0.120006 15.12 1.67999 14.76H24C24.72 14.76 25.44 14.76 25.8 14.04C26.52 13.68 26.88 12.96 26.88 11.88V8.63999C26.88 7.91999 26.52 7.19999 25.8 6.83999C25.44 6.11999 24.72 5.75999 24 5.75999H7.07999V7.91999C7.07999 8.63999 6.35999 8.99999 5.27999 8.63999L0.959994 5.39999C-0.120006 4.67999 -0.120006 3.95999 0.959994 3.23999L5.27999 0.35999C6.35999 -0.36001 7.07999 -9.51998e-06 7.07999 0.719991V2.87999Z"
                fill="#153038"
              />
            </g>
            <defs>
              <clipPath id="clip0_54_92">
                <rect width="30" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        {(window.location.pathname === "/add-car" &&
          !localStorage.getItem("addCarInfoCheck")) ||
        (window.location.pathname === "/short-terms" &&
          !localStorage.getItem("shortInfoCheck")) ||
        (window.location.pathname === "/car-details" &&
          !localStorage.getItem("carDetailsInfoCHeck")) ||
        (window.location.pathname.includes("/piece-details/") &&
          !localStorage.getItem("pieceDetailsInfoCHeck")) ? (
          <div
            className={`absolute  top-[8vw] -translate-y-[50%]  ${
              window.location.pathname === "/car-details" ||
              window.location.pathname.includes("/piece-details/")
                ? " left-[18vw] "
                : "left-[5vw]"
            } `}
            onClick={(e) => {
              e.stopPropagation();
              contextData.setIsInfoOpen(true);
              if (window.location.pathname === "/short-terms") {
                localStorage.setItem("shortInfoCheck", true);
              }
              if (window.location.pathname === "/add-car") {
                localStorage.setItem("addCarInfoCheck", true);
              }
              if (window.location.pathname === "/car-details") {
                localStorage.setItem("carDetailsInfoCHeck", true);
              }
              if (window.location.pathname.includes("/piece-details/")) {
                localStorage.setItem("pieceDetailsInfoCHeck", true);
              }
            }}
          >
            <BsQuestionCircle size={20} className="blink" />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
